const CONST_HOUSE_OWNER_USER_TYPE = 8;
const CONST_COMPANY_LICENSE_FILE_TYPE = 1;
const CONST_LEGAL_PERSON_FILE_TYPE = 2;
const CONST_RENT_CONTRACT_FILE_TYPE = 3;
const CONST_SHARE_HOLDERS_FILE_TYPE = 4;
const CONST_COMPANY_APPLY_SIGN_FILE_TYPE = 5;
const CONST_OPERATOR_AGREE_SIGN_FILE_TYPE = 6;
const COMPANY_APPLY_NOTICE_FILE_TYPE = 7;
const CONST_OHTER_ATTACHEMENT_FILE_TYPE = 8;
const CONST_APPLY_SUCCESS_FILE_TYPE = 10;
const BUSINESS_TYPE_IN = 1;
const BUSINESS_TYPE_CHANGE = 2;
const BUSINESS_TYPE_COMPANY_LICENSE = 3;
const BUSINESS_TYPE_PROOF_OF_USE = 4;
export default {
    CONST_HOUSE_OWNER_USER_TYPE,
    CONST_COMPANY_LICENSE_FILE_TYPE,
    CONST_LEGAL_PERSON_FILE_TYPE,
    CONST_RENT_CONTRACT_FILE_TYPE,
    CONST_SHARE_HOLDERS_FILE_TYPE,
    CONST_COMPANY_APPLY_SIGN_FILE_TYPE,
    CONST_OPERATOR_AGREE_SIGN_FILE_TYPE,
    COMPANY_APPLY_NOTICE_FILE_TYPE,
    CONST_APPLY_SUCCESS_FILE_TYPE,
    CONST_OHTER_ATTACHEMENT_FILE_TYPE,
    BUSINESS_TYPE_IN,
    BUSINESS_TYPE_CHANGE,
    BUSINESS_TYPE_COMPANY_LICENSE,
    BUSINESS_TYPE_PROOF_OF_USE
}
